import { Accordion } from '@mantine/core';

// import '/Accordion.module.css'; // Ensure you have the correct path to your Accordion styles

function MyAccordionComponent({ content }) {
    const items = content.map((item) => (
        <Accordion.Item key={item.title} value={item.title}>
            <Accordion.Control>
                {item.title}
            </Accordion.Control>
            <Accordion.Panel>
                <p className="px-4  text-gray-700 dark:text-gray-200">
                    {item.contentParagraph}
                </p>
            </Accordion.Panel>
        </Accordion.Item>
    ));

    return (
        <Accordion
            variant="contained"
            classNames={{
                control: " font-semibold text-lg bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white",
                panel: "px-5 py-4 bg-white dark:bg-gray-900",
            }}
            radius="md"
            defaultValue={content[0]?.title}
        >
            {items}
        </Accordion>
    );
}

export default MyAccordionComponent;